module.exports = __webpack_public_path__ + "img/jppdimg_mo4.6e6c0385.png";